import { applyByKey } from 'utils/reducerHelpers';
import {
  LOAD_SUPPLIERS_START,
  LOAD_SUPPLIERS_SUCCESS,
  LOAD_SUPPLIERS_ERROR,
  LOAD_SWITCHSUPPLIER_START,
  LOAD_SWITCHSUPPLIER_SUCCESS,
  LOAD_SWITCHSUPPLIER_ERROR,
} from './suppliers.actions';

function mapSuppliersFromResponse(suppliers) {
  if (suppliers != null) {
    return suppliers.map(supplier => ({ ...supplier }));
  }
  return null;
}

export default function suppliersReducer(state = {}, action) {
  const { key } = action;

  switch (action.type) {
    case LOAD_SUPPLIERS_START:
      return applyByKey(key, state, () => ({
        loading: true,
        error: false
      }));
    case LOAD_SUPPLIERS_ERROR:
      return applyByKey(key, state, () => ({
        loading: false,
        error: true
      }));
    case LOAD_SUPPLIERS_SUCCESS:
      return applyByKey(key, state, () => ({
        loading: false,
        suppliers: mapSuppliersFromResponse(action.response.data)
      }));
    case LOAD_SWITCHSUPPLIER_START:
      return applyByKey(key, state, () => ({
        switching: true,
        redirectUrl: undefined
      }));
    case LOAD_SWITCHSUPPLIER_SUCCESS:
      return applyByKey(key, state, () => ({
        switching: false,
        redirectUrl: action.response.data.redirectUrl || action.response.data.ssoUrl,
        error: false
      }));
    case LOAD_SWITCHSUPPLIER_ERROR:
      return applyByKey(key, state, () => ({
        switching: false,
        error: true
      }));
    default:
      return state;
  }
}
